// Import React Library
import React, { useState, useEffect } from 'react';

// Import Icons
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';
import FlagIcon from '@mui/icons-material/Flag';

// Import Tootltips
import Tooltip from '@mui/material/Tooltip';

// Location Component
const Location = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Function to handle complete charge.
        const handleLoad = () => {
          setIsLoading(false);
        };
    
        // Adding charge event to load.
        window.addEventListener('load', handleLoad);
    
        // Clean event.
        return () => {
          window.removeEventListener('load', handleLoad);
        };
      }, []);


    return (
        <div id='location-section' className='location'>
            <div className='location-maps location-container locations-mapas'>    
                 <div className='local-point'>
                    <Tooltip title="Local comercial abierto a todo el publico." arrow placement="top-start">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3276.770558037734!2d-56.00290192343443!3d-34.786550972889465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDQ3JzExLjYiUyA1NsKwMDAnMDEuMiJX!5e0!3m2!1ses!2suy!4v1750091179209!5m2!1ses!2suy" width="" height=""  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>                    
                    </Tooltip>
                </div>

                <div className='local-point'>
                    <Tooltip title="Local comercial abierto a todo el publico." arrow placement="top-start">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d209547.8504145985!2d-56.28468451252846!3d-34.851574492059505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a0265d397087e7%3A0x554e4a1dbdfbe70c!2sPreHouse%20Uruguay!5e0!3m2!1ses!2suy!4v1718126650530!5m2!1ses!2suy" width="" height="" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> 
                    </Tooltip>
                </div>

            
                <div className='local-point'>
                    <Tooltip title="Deposito logistico de mercaderia." arrow placement="top-end">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13108.176239719092!2d-56.00951!3d-34.7796661!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a0279dc49ae6db%3A0x8dfd75c13216dcb0!2sParque%20Empresarial%20Camino%20Ventura!5e0!3m2!1ses!2suy!4v1733249353232!5m2!1ses!2suy" width="" height="" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>                    
                    </Tooltip>
                </div>
            </div>

            <div className='location-container location-texts'>
                <h2 className='text-gray-800'>UBICACIÓN<LocationOnIcon fontSize='large' className='location-icon'/></h2>
                <span></span>
                <p className='text-gray-800'>Nuestra ubicación estratégica facilita el acceso y salida de los productos a cualquier punto del país haciendo de la experiencia un proceso agradable y cómodo.</p>       
                <br />

                <div className='location-data'>
                    <FlagIcon fontSize='large' className='business-icon text-gray-800'/>
                    <h3 className='text-gray-800'>Ruta 101 - KM 26</h3>
                    <p className='text-gray-800'>Local comercial abierto al publico.</p>
                </div>

                <div className='location-data'>
                    <FlagIcon fontSize='large' className='business-icon text-gray-800'/>
                    <h3 className='text-gray-800'>Ruta 8 - KM 27.100 - Parada 33</h3>
                    <p className='text-gray-800'>Local comercial abierto al publico.</p>
                </div>

                <div className='location-data'>
                    <BusinessIcon fontSize='large' className='business-icon text-gray-800'/>
                    <h3 className='text-gray-800'>Centro logistico Parque Ventura</h3>
                    <p className='text-gray-800'>Deposito.</p>
                </div>
            </div>
        </div>
    );
};

// Export Location Component
export default Location;
